<template>
  <div class="ele-body">
    <el-card shadow="never" body-style="padding-bottom:0;">
      <el-row :gutter="15">
        <el-col :md="6" style="margin-bottom: 15px">
          <!-- 操作按钮 -->
          <div class="ele-table-tool ele-table-tool-default">
            <el-button @click="showEdit = true" type="primary" icon="el-icon-plus" class="ele-btn-icon" size="small">添加 </el-button>
            <el-button @click="edit" type="warning" icon="el-icon-edit" class="ele-btn-icon" :disabled="!current" size="small">修改 </el-button>
            <el-button @click="remove" type="danger" icon="el-icon-delete" class="ele-btn-icon" :disabled="!current" size="small">删除 </el-button>
          </div>
          <!-- 数据表格 -->
          <ele-data-table
            ref="table"
            :config="table"
            :current.sync="current"
            @done="done"
            highlight-current-row
            :height="tbHeight"
            class="dict-table"
          >
            <el-table-column type="index" width="45" align="center" />
            <el-table-column prop="groupName" label="工作组名称" show-overflow-tooltip>
              <template #default="{ row }">{{ row.groupName }}</template>
            </el-table-column>
          </ele-data-table>
        </el-col>
        <el-col :md="18" style="margin-bottom: 15px">
          <teacher-list v-if="current" :id="current.id" :tb-height="tbHeight" />
        </el-col>
      </el-row>
    </el-card>
    <!-- 编辑弹窗 -->
    <el-dialog
      :title="editForm.id ? '修改工作组' : '添加工作组'"
      :visible.sync="showEdit"
      width="400px"
      @closed="editForm = {}"
      :destroy-on-close="true"
      :lock-scroll="false"
    >
      <el-form :model="editForm" ref="editForm" :rules="editRules" label-width="100px">
        <el-form-item label="工作组名称:" prop="groupName">
          <el-input v-model="editForm.groupName" placeholder="请输入工作组名称" clearable />
        </el-form-item>
        <el-form-item label="排序号:" prop="orderNum">
          <el-input-number
            v-model="editForm.orderNum"
            controls-position="right"
            :min="0"
            placeholder="请输入排序号"
            class="ele-fluid ele-text-left"
          />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="showEdit = false">取消</el-button>
        <el-button type="primary" @click="save(editForm.id)">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import TeacherList from '@/views/school/group/teacher-list';
  import { addGroup, updateGroup, deleteGroup } from '@/config/api';

  export default {
    name: 'SysGroup',
    components: { TeacherList },
    data() {
      return {
        table: {
          // 表格配置
          url: '/group/getTeacherAllGroup',
          page: false,
          where: {},
          parseData(res) {
            if (res.resCode == 200) res.code = 0;
            return res;
          },
        },
        current: null, // 表格选中数据
        showEdit: false, // 是否显示表单弹窗
        editForm: {}, // 表单数据
        editRules: {
          // 表单验证规则
          groupName: [{ required: true, message: '请输入工作组名称', trigger: 'blur' }],
          orderNum: [{ required: true, message: '请输入序号', trigger: 'blur' }],
        },
      };
    },
    computed: {
      /* 表格固定高度 */
      tbHeight() {
        return this.$store.state.theme.screenWidth < 992 ? undefined : 'calc(100vh - 214px)';
      },
    },
    methods: {
      /* 表格渲染完成回调 */
      done(res) {
        if (res.data.length > 0) this.$refs.table.setCurrentRow(res.data[0]);
      },
      /* 显示编辑 */
      edit() {
        this.editForm = Object.assign({}, this.current);
        this.showEdit = true;
      },
      /* 保存编辑 */
      save(uid) {
        this.$refs['editForm'].validate((valid) => {
          if (valid) {
            const loading = this.$loading({ lock: true });
            let formData = new FormData();
            for (let key in this.editForm) {
              if (this.editForm[key] !== null && this.editForm[key] !== undefined) {
                formData.append(key, this.editForm[key]);
              }
            }
            if (uid == undefined) {
              //添加工作组
              addGroup(formData).then((res) => {
                loading.close();
                if (res.data.resCode == 200) {
                  this.showEdit = false;
                  this.$message({ type: 'success', message: res.data.resMsg });
                  this.$refs.table.reload();
                } else {
                  this.$message.error(res.data.resMsg);
                }
              });
            } else {
              //更改工作组
              updateGroup(formData).then((res) => {
                loading.close();
                if (res.data.resCode == 200) {
                  this.showEdit = false;
                  this.$message({ type: 'success', message: res.data.resMsg });
                  this.$refs.table.reload();
                } else {
                  this.$message.error(res.data.resMsg);
                }
              });
            }
          } else {
            return false;
          }
        });
      },
      /* 删除 */
      remove() {
        this.$confirm('确定要删除选中的工作组吗?', '提示', {
          type: 'warning',
        }).then(() => {
          const loading = this.$loading({ lock: true });
          let formData = new FormData();
          formData.append('id', this.current.id);
          deleteGroup(formData).then((res) => {
            loading.close();
            if (res.data.resCode == 200) {
              this.showEdit = false;
              this.$message({ type: 'success', message: res.data.resMsg });
              this.$refs.table.reload();
            } else {
              this.$message.error(res.data.resMsg);
            }
          });
        });
      },
    },
  };
</script>

<style scoped>
  .dict-table >>> .el-table__row {
    cursor: pointer;
  }

  .dict-table >>> .el-table__row > td:last-child:after {
    content: '\e6e0';
    font-family: element-icons !important;
    font-style: normal;
    font-variant: normal;
    text-transform: none;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    line-height: 1;
    position: absolute;
    right: 10px;
    top: 50%;
    margin-top: -7px;
  }

  .dict-table >>> .el-table__row > td:last-child .cell {
    padding-right: 20px;
  }
</style>
